/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IFindOnboardingMotorCarrierQueryVariables = Types.Exact<{
  dotNumber?: Types.Maybe<Types.Scalars['Int']>
  mcNumber?: Types.Maybe<Types.Scalars['Int']>
}>

export type IFindOnboardingMotorCarrierQuery = { __typename?: 'Query' } & {
  findOnboardingMotorCarrier?: Types.Maybe<
    { __typename?: 'OnboardingMotorCarrier' } & Pick<
      Types.IOnboardingMotorCarrier,
      | 'id'
      | 'ein'
      | 'highwayId'
      | 'continuousAuthorityGrantDate'
      | 'dotNumber'
      | 'mcNumber'
      | 'legalName'
      | 'dbaName'
    > & {
        contacts?: Types.Maybe<
          Array<
            { __typename?: 'HighwayContact' } & Pick<
              Types.IHighwayContact,
              'name' | 'isType' | 'emailAddress' | 'phone' | 'id'
            >
          >
        >
        addresses?: Types.Maybe<
          Array<
            { __typename?: 'HighwayAddress' } & Pick<
              Types.IHighwayAddress,
              | 'id'
              | 'city'
              | 'countryCode'
              | 'isType'
              | 'postalCode'
              | 'stateCode'
              | 'street1'
              | 'street2'
            >
          >
        >
        rulesAssessments?: Types.Maybe<
          Array<
            { __typename?: 'HighwayRulesAssessment' } & Pick<
              Types.IHighwayRulesAssessment,
              'id' | 'classificationName' | 'overrides' | 'ruleName' | 'result'
            >
          >
        >
        insurancePolicies?: Types.Maybe<
          Array<
            { __typename?: 'HighwayInsurancePolicy' } & Pick<
              Types.IHighwayInsurancePolicy,
              'id' | 'coverageLimit' | 'expirationDate' | 'isType' | 'policyNumber' | 'status'
            > & {
                insurer?: Types.Maybe<
                  { __typename?: 'HighwayInsurer' } & Pick<
                    Types.IHighwayInsurer,
                    'id' | 'naic' | 'name'
                  >
                >
              }
          >
        >
        users: { __typename?: 'MotorCarrierUserConnection' } & {
          nodes?: Types.Maybe<
            Array<
              Types.Maybe<
                { __typename?: 'MotorCarrierUser' } & Pick<Types.IMotorCarrierUser, 'id'> & {
                    dispatcher?: Types.Maybe<
                      { __typename?: 'Dispatcher' } & Pick<Types.IDispatcher, 'id' | 'maskedEmail'>
                    >
                  }
              >
            >
          >
        }
      }
  >
}

export const FindOnboardingMotorCarrierDocument = gql`
  query FindOnboardingMotorCarrier($dotNumber: Int, $mcNumber: Int) {
    findOnboardingMotorCarrier(dotNumber: $dotNumber, mcNumber: $mcNumber) {
      id
      contacts {
        name
        isType
        emailAddress
        phone
        id
      }
      ein
      highwayId
      continuousAuthorityGrantDate
      addresses {
        id
        city
        countryCode
        isType
        postalCode
        stateCode
        street1
        street2
      }
      rulesAssessments {
        id
        classificationName
        overrides
        ruleName
        result
      }
      insurancePolicies {
        id
        coverageLimit
        expirationDate
        isType
        policyNumber
        status
        insurer {
          id
          naic
          name
        }
      }
      dotNumber
      mcNumber
      legalName
      dbaName
      users(role: admin, type: [dispatcher, owner_operator]) {
        nodes {
          id
          dispatcher {
            id
            maskedEmail
          }
        }
      }
    }
  }
`

/**
 * __useFindOnboardingMotorCarrierQuery__
 *
 * To run a query within a React component, call `useFindOnboardingMotorCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOnboardingMotorCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOnboardingMotorCarrierQuery({
 *   variables: {
 *      dotNumber: // value for 'dotNumber'
 *      mcNumber: // value for 'mcNumber'
 *   },
 * });
 */
export function useFindOnboardingMotorCarrierQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IFindOnboardingMotorCarrierQuery,
    IFindOnboardingMotorCarrierQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IFindOnboardingMotorCarrierQuery,
    IFindOnboardingMotorCarrierQueryVariables
  >(FindOnboardingMotorCarrierDocument, options)
}
export function useFindOnboardingMotorCarrierLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IFindOnboardingMotorCarrierQuery,
    IFindOnboardingMotorCarrierQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IFindOnboardingMotorCarrierQuery,
    IFindOnboardingMotorCarrierQueryVariables
  >(FindOnboardingMotorCarrierDocument, options)
}
export type FindOnboardingMotorCarrierQueryHookResult = ReturnType<
  typeof useFindOnboardingMotorCarrierQuery
>
export type FindOnboardingMotorCarrierLazyQueryHookResult = ReturnType<
  typeof useFindOnboardingMotorCarrierLazyQuery
>
export type FindOnboardingMotorCarrierQueryResult = Apollo.QueryResult<
  IFindOnboardingMotorCarrierQuery,
  IFindOnboardingMotorCarrierQueryVariables
>
